import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><g fill="#2e3436"><path d="M5.1 0a1 1 0 00-.707.293l-4.1 4.1A1 1 0 000 5.1v5.8a1 1 0 00.293.707l4.1 4.1A1 1 0 005.1 16h3.894a1 1 0 100-2H5.516L2 10.484V5.516L5.516 2h4.968L14 5.514l-.006 3.484a1 1 0 102 .004l.006-3.9a1 1 0 00-.293-.71l-4.1-4.099A1 1 0 0010.9 0z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal"
      }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" opacity={0.35} /><path d="M6.994 4h2v3l-.25 2H7.275l-.28-2zm1 5.75a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z" style={{
        lineHeight: "normal",
        InkscapeFontSpecification: "Sans",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textTransform: "none",
        marker: "none"
      }} color="#000" fontWeight={400} fontFamily="Sans" overflow="visible" opacity={0.35} /><path d="M10.994 11h1.375l1.125 1.094L14.588 11h1.406v1.469L14.9 13.53l1.094 1.063V16h-1.437l-1.063-1.063L12.432 16h-1.438v-1.406l1.063-1.063-1.063-1.062z" style={{
        marker: "none"
      }} color="#bebebe" overflow="visible" /></g></svg>;
}

export default SvgComponent;